import React from 'react';
import { ReactComponent as PaymongoLogo } from 'app/assets/images/paymongoLogo.svg';
import { ReactComponent as GCashIcon } from 'app/assets/images/gcashIcon.svg';
import { ReactComponent as MayaIcon } from 'app/assets/images/mayaIcon.svg';
import { ReactComponent as GrabPayIcon } from 'app/assets/images/grabpayIcon.svg';

export const PaymentServiceLogos: React.FC = () => {
  return (
    <>
      <div className="d-flex d-flex_justify-between d-flex_align-center mb-6">
        <GCashIcon />
        <MayaIcon className="mt-3" />
        <GrabPayIcon />
      </div>
      <div className="d-flex d-flex_justify-center mb-6">
        <PaymongoLogo />
      </div>
    </>
  );
};
